<div class="flyout-kpi-settings">
  <div class="flyout-kpi-settings-header">
    <h3 class="flyout-kpi-settings-title">{{ "dashboard-new.kpi-settings.title" | translate }}</h3>
    <button class="flyout-kpi-settings-close" (click)="closeFlyout()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p class="flyout-kpi-settings-subtitle">{{ subtitleKey | translate }}</p>

  @if (hasDefaults) {
    <div class="flyout-kpi-settings-actions">
      <button class="flyout-kpi-reset-btn" (click)="resetToDefault()">
        <mat-icon fontSet="material-symbols-outlined">restart_alt</mat-icon>
        <span>{{ "dashboard-new.kpi-settings.reset-to-default" | translate }}</span>
      </button>
    </div>
  }

  @if (hasMetricGroups) {
    <!-- Grouped: each metric group gets its own added (reorderable) + available list. -->
    @for (group of groupedDefinitions(); track group.key) {
      <div class="flyout-kpi-section flyout-kpi-section--available">
        <p class="flyout-kpi-section-label">{{ group.labelKey | translate }}</p>
        <div class="flyout-kpi-added-list" cdkDropList (cdkDropListDropped)="dropKpiInGroup($event, group.key)">
          @for (kpi of group.added; track kpi.key) {
            <div class="flyout-kpi-settings-row flyout-kpi-settings-row--added" cdkDrag>
              <div class="flyout-kpi-row-top">
                <mat-icon class="flyout-kpi-drag-handle" cdkDragHandle>drag_indicator</mat-icon>
                <div class="flyout-kpi-row-label">
                  <span>{{ kpi.labelKey | translate }}</span>
                  @if (kpi.experimental) {
                    <span class="kpi-experimental-tag">{{ "dashboard-new.kpi-settings.experimental" | translate }}</span>
                  }
                  @if (kpi.tooltipKey) {
                    <mat-icon class="kpi-definition-info-icon" [matTooltip]="kpi.tooltipKey | translate" matTooltipPosition="right" matTooltipShowDelay="200">
                      info
                    </mat-icon>
                  }
                </div>
                <button class="flyout-kpi-remove-btn" (click)="removeKpi(kpi.key)">
                  <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
        @for (kpi of group.available; track kpi.key) {
          <div class="flyout-kpi-settings-row">
            <div class="flyout-kpi-row-label">
              <span>{{ kpi.labelKey | translate }}</span>
              @if (kpi.experimental) {
                <span class="kpi-experimental-tag">{{ "dashboard-new.kpi-settings.experimental" | translate }}</span>
              }
              @if (kpi.tooltipKey) {
                <mat-icon class="kpi-definition-info-icon" [matTooltip]="kpi.tooltipKey | translate" matTooltipPosition="right" matTooltipShowDelay="200">
                  info
                </mat-icon>
              }
            </div>
            <button class="flyout-kpi-add-btn" (click)="addKpi(kpi.key)" [disabled]="group.isFull">
              {{ "dashboard-new.kpi-settings.add" | translate }}
            </button>
          </div>
        }
      </div>
    }
  } @else {
    <div class="flyout-kpi-section">
      <p class="flyout-kpi-section-label">{{ "dashboard-new.kpi-settings.added-metrics" | translate }}</p>
      @if (addedDefinitions().length === 0) {
        <p class="flyout-kpi-section-empty">{{ "dashboard-new.kpi-settings.no-added-metrics" | translate }}</p>
      }
      <div class="flyout-kpi-added-list" cdkDropList (cdkDropListDropped)="dropKpi($event)">
        @for (kpi of addedDefinitions(); track kpi.key) {
          <div class="flyout-kpi-settings-row flyout-kpi-settings-row--added" cdkDrag>
            <div class="flyout-kpi-row-top">
              <mat-icon class="flyout-kpi-drag-handle" cdkDragHandle>drag_indicator</mat-icon>
              <div class="flyout-kpi-row-label">
                <span>{{ kpi.labelKey | translate }}</span>
                @if (kpi.experimental) {
                  <span class="kpi-experimental-tag">{{ "dashboard-new.kpi-settings.experimental" | translate }}</span>
                }
                @if (kpi.tooltipKey) {
                  <mat-icon class="kpi-definition-info-icon" [matTooltip]="kpi.tooltipKey | translate" matTooltipPosition="right" matTooltipShowDelay="200">
                    info
                  </mat-icon>
                }
              </div>
              <button class="flyout-kpi-remove-btn" (click)="removeKpi(kpi.key)">
                <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="flyout-kpi-section flyout-kpi-section--available">
      <p class="flyout-kpi-section-label">{{ "dashboard-new.kpi-settings.available-metrics" | translate }}</p>
      @if (availableDefinitions().length === 0) {
        <p class="flyout-kpi-section-empty">{{ "dashboard-new.kpi-settings.all-added" | translate }}</p>
      }
      @for (kpi of availableDefinitions(); track kpi.key) {
        <div class="flyout-kpi-settings-row">
          <div class="flyout-kpi-row-label">
            <span>{{ kpi.labelKey | translate }}</span>
            @if (kpi.experimental) {
              <span class="kpi-experimental-tag">{{ "dashboard-new.kpi-settings.experimental" | translate }}</span>
            }
            @if (kpi.tooltipKey) {
              <mat-icon class="kpi-definition-info-icon" [matTooltip]="kpi.tooltipKey | translate" matTooltipPosition="right" matTooltipShowDelay="200">
                info
              </mat-icon>
            }
          </div>
          <button class="flyout-kpi-add-btn" (click)="addKpi(kpi.key)" [disabled]="isFull()">
            {{ "dashboard-new.kpi-settings.add" | translate }}
          </button>
        </div>
      }
    </div>
  }

  @if (hasSections) {
    <div class="flyout-kpi-section flyout-kpi-section--available">
      <p class="flyout-kpi-section-label">{{ "dashboard-new.kpi-settings.sections" | translate }}</p>
      @for (section of sectionRows(); track section.key) {
        <div class="flyout-kpi-settings-row" [class.flyout-kpi-settings-row--disabled]="section.disabled">
          <div class="flyout-kpi-row-label">
            <span>{{ section.labelKey | translate }}</span>
            @if (section.disabled && section.disabledNoteKey) {
              <span class="flyout-kpi-section-disabled-note">{{ section.disabledNoteKey | translate }}</span>
            }
          </div>
          @if (section.disabled) {
            <button class="flyout-kpi-add-btn" disabled>
              {{ "dashboard-new.kpi-settings.add" | translate }}
            </button>
          } @else if (section.selected) {
            <button class="flyout-kpi-remove-btn" (click)="toggleSection(section.key)">
              <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
            </button>
          } @else {
            <button class="flyout-kpi-add-btn" (click)="toggleSection(section.key)">
              {{ "dashboard-new.kpi-settings.add" | translate }}
            </button>
          }
        </div>
      }
    </div>
  }
</div>
